<div class="venue-add-part">
	<div class='d-flex flex-column gap-2 p-2'>
		<div>Search for a Venue:</div>
		<common-address-field [field]="address()"></common-address-field>
	</div>


	<common-button-row [center]="true">
		<button #venueFormAddBtn class="btn btn-primary">Add</button>
	</common-button-row>
</div>